import OpenApiClient from "@shared/api/OpenApiClient.ts";

/**
 * Асинхронно получает URL для магазина игры.
 * Если требуется, создает временный токен для бесшовного перехода.
 * @param game - Системное имя игры.
 * @param redirectWithTempToken - Нужно ли создавать временный токен.
 * @returns {Promise<URL>} - Сгенерированный URL.
 */
export const getGameStoreUrl = async (game: string, redirectWithTempToken: boolean): Promise<URL> => {
	if (redirectWithTempToken) {
		const { TempToken } = await OpenApiClient.Auth.fxIdWebFeaturesAuthCreateTempTokenEndpoint({
			RedirectUri: `/Store/${game}`
		});
		const url = new URL(`/LoginWithTempToken`, window.location.origin);
		url.searchParams.append("token", TempToken);
		log.info(`Generated temp token store URL: ${url}`);
		return url;
	}

	const url = new URL(`Store/${game}`, window.location.origin);
	log.info(`Generated direct store URL: ${url}`);
	return url;
};
